
import Vue from 'vue'
import { createPlatformState, platformAction, platformGetters, platformMutations } from '~/helpers/store'
import { MEMBERSHIP_PAYMENT } from '~/constants'

export default {
  state: () => createPlatformState(),
  actions: {
    async createForm ({ commit, rootGetters }, host) {
      const form = await platformAction({
        client: this.$api.payments.forms,
        method: 'create',
        commit,
        logError: this.$logError,
        commitData: false,
        params: {
          venueId: 'GRS',
          memberId: rootGetters['user/account/id'],
          transactionType: 'transactional',
          gatewayAttributes: {
            callbackUrl: `${host}/settings/payment/callback`,
            applicationId: 'DIH'
          },
          useSca: true
        }
      })
      commit('saveForm', form)
    },

    async createMembershipForm ({ commit, rootGetters }, { host, venueId, id }) {
      const form = await platformAction({
        client: this.$api.payments.forms,
        method: 'create',
        commit,
        logError: this.$logError,
        commitData: false,
        params: {
          venueId,
          memberId: rootGetters['user/account/id'],
          transactionType: 'membership',
          gatewayAttributes: {
            callbackUrl: `${host}/apply/${id}/pay?${MEMBERSHIP_PAYMENT.SUCCESS_QUERY}=true`,
            applicationId: 'DIH'
          },
          useSca: true
        }
      })
      commit('saveForm', form)
    }
  },
  getters: {
    ...platformGetters,
    form: s => s.data
  },
  mutations: {
    ...platformMutations,
    saveForm: (s, form) => {
      Vue.set(s, 'data', form)
    }
  }
}
